import { PartyTypes, AuctionStatuses } from 'vdlib';

const RoleStatusColumnsDefs = {
  [`${PartyTypes.Operator}_${AuctionStatuses.Pending}`]: [
    'ID',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'CreatedDate',
    'Από Αρχείο',
    'Λεπτομέρειες',
    // --------''selection',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.Active}`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Best',
    'Υπ. Χρόνος',
    'Λεπτομέρειες',
  ],
  [`${PartyTypes.Operator}_NoOffer`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Υπ. Χρόνος',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.ForSelection}`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Εμπορική Αξία',
    'Best',
    'EndDate',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.ForAcceptance}`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.Finished}`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Pending}`]: [
    'ID',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'CreatedDate',
    'Από Αρχείο',
    'Λεπτομέρειες',
    // --------''selection',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Active}`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Best',
    'Υπ. Χρόνος',
    'Λεπτομέρειες',
  ],
  [`${PartyTypes.Admin_Insurance}_NoOffer`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Υπ. Χρόνος',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.ForSelection}`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Εμπορική Αξία',
    'Best',
    'EndDate',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.ForAcceptance}`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Finished}`]: [
    'ID',
    'Φωτογραφίες',
    'Ασφαλιστική',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.Active}`]: [
    'ID',
    'Φωτογραφίες',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Υπ. Χρόνος',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.Pending}`]: [
    'ID',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Εμπορική Αξία',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.ForSelection}`]: [
    'ID',
    'Φωτογραφίες',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Best',
    'EndDate',
    'Επιλογή',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.ForAcceptance}`]: [
    'ID',
    'Φωτογραφίες',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Αποδεχθείσα Προσφορά',
    'EndDate',
    'InfoPDF',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.Finished}`]: [
    'ID',
    'Φωτογραφίες',
    'Φάκελος-Πινακίδα',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Αποδεχθείσα Προσφορά',
    'EndDate',
    'InfoPDF',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.Active}`]: [
    'ID',
    'Φωτογραφίες',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Προσφορά Εμπόρου',
    'Υπ. Χρόνος',
    'Προσφορά',
  ],

  [`${PartyTypes.Merchant}_Participate`]: [
    'ID',
    'Φωτογραφίες',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    // 'Αποτέλεσμα',
    'Προσφορά Εμπόρου',
    'EndDate',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Merchant}_Lost`]: [
    'ID',
    'Φωτογραφίες',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'Reason',
    'EndDate',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.ForAcceptance}`]: [
    'ID',
    'Φωτογραφίες',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Προσφορά Εμπόρου',
    'Αποδοχή',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.Finished}`]: [
    'ID',
    'Φωτογραφίες',
    'Όχημα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Προσφορά Εμπόρου',
    'Λεπτομέρειες',
  ],
};

export default RoleStatusColumnsDefs;
